// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iC","advertCardFooter__row":"c-a_iE","advertCardFooter__name":"c-a_iF","advertCardFooter__price":"c-a_iG","advertCardFooter__age":"c-a_iH"};